module.exports = __webpack_public_path__ + "img/main-gallery2-mob.f98da99c.jpg";